// extracted by mini-css-extract-plugin
export default {"sendContainer":"AdminChatSend_sendContainer__rKRSN","input":"AdminChatSend_input__mYuVb","sendButton":"AdminChatSend_sendButton__J3zX4"};